module.exports = __webpack_public_path__ + "img/logo-factory.9dcccb2a.svg";